import { for_farmers_en } from "./forFarmers";
import { detailsAboutSlide_en } from "./detailsAboutSlide"
import { labs_en } from "./labs"
import { footerFormEn } from "./footerForm"
import { consulting_cn } from "./consulting";
import { products_en } from './products'
import { trading_en } from "./trading"
import { en_testing } from "./testing";

const en = {
    search: 'Search',
    aboutUs: 'О нас',
    aboutCompany: 'About company',
    news: 'Media',
    production: 'Production',
    Technologies: 'Технологии',
    catalog: 'Products',
    labs: 'Лабораторные исследования',
    contacts: 'Contacts',
    productions: "Productions",
    productionLower: 'productions',
    megakorm: 'Megakorm',
    partners: 'Partners',
    megamix: 'MegaMix',
    details: 'Details',
    laboratories: "Laboratories",
    vacancy: "Vacancies",
    products: "Products",
    farmers: 'Farmers',
    megamixForFarmers: 'Media Center',
    productsIngredientsAdditivesAndFeedSolutions: 'Products: ingredients, additives and feed solutions',
    consulting: 'Consulting',
    laboratoriesP: 'Personal account',
    trading: 'Trading',
    export: 'Export',
    clients: 'Сlients',
    weFeedThoseWhoFeedUs: "We feed those ",
    weFeedThoseWhoFeedUs1: "who feed us",
    ecosystemOfMEGAMIXGROUP: "Ecosystem of MEGAMIX GROUP – the largest producer of premix, compound feed and protein-vitamin-mineral supplements for all species of livestock and poultry",
    learnMore: "Learn more",
    aboutCompany: "About company",
    aboutCompanyLower: "about company",
    forCustomers: "customers",
    customOrder: "Custom order",
    customOrderText: "We are a leading company in premix production and feed ingredient supply in the domestic market. For large orders, Megamix offers customized formulation based on the available raw material base. Benefits of our company include our own scientific and technological base that enables us to make correct calculations and complete various tasks, as well as great logistics capabilities.",
    customOrderText1: "Production sites and ingredient storage facilities of MEGAMIX GROUP comply with global standards, which guarantees high product quality. To place a custom order, please fill out the feedback form below or contact us by phone.",
    sendEnquiry: "Send enquiry",
    eventsTitle: "Events",
    upcomingEvents: "upcoming events",
    featuringMegamix: "featuring Megamix",
    newsTitle: "News",
    usefulMaterialsTitle: "Blog",
    Feedback: "Feedback",
    distributors: "distributors",
    footerText: "We have more than 200 distributors throughout Russia and the near abroad. You can find a suitable distributor on the website of our main product line.",
    onMegakorm: "On Megakorm website",
    weAreInTouch: "We are in touch from Monday to Friday, from 9:00 to 17:00. You can",
    orderACall: "order a call",
    WeAreReadyToAcceptYourRequestByMail: "We are ready to accept your request by mail",
    DownloadPressKit: "Download the press kit, 18 mb",
    PressService: "Press Service",
    FeedbackText: "Have you decided on the order or do you need additional information? Contact us by filling out the feedback form to receive all necessary consultations and prompt support of the order.",
    send: "Send",
    megamixB2B: "Megamix b2b",
    LegalInformation: "Legal information",
    PersonalDataProcessing: "Personal Data Processing",
    MegamixGroup: `Megamix Group`,
    BackToMap: "Back to map",
    b2bText1: "The Megamix Group of companies combines reliability, innovation and professionalism in the production of premixes, feed additives, BVMC and compound feeds.",
    b2bText2: "Our clients are not just enterprises, they are partners, hundreds of companies, including both large agricultural holdings and medium-sized businesses, both in Russia and abroad. We are proud that with our products and solutions, our partners are reaching new heights of production and efficiency.",
    MegamixToday: "Megamix today",
    bestInRussia: "#1 in Russia",
    bestInRussiaAbout: "Largest premix producer in Russia and one of the top producers in Europe",
    productionsCount: "6 Production Sites",
    productionsCountAbout: "Six production sites operating under international standards",
    percentInRussia: "32% of Russian Market",
    percentInRussiaAbout: "32% of compound feed produced in Russia is based on Megamix premix",
    percentGlobal: "1% of Global Market",
    percentGlobalAbout: "1% of the global animal nutrition market",
    WorldsFirstVitE60: "World's First Vit E 60% Powder",
    WorldsFirstVitE60About: "First to produce feed grade vitamin E 60% powder in the world",
    LaboratoriesCount: "3 Laboratories",
    LaboratoriesCountAbout: "Three accredited research laboratories",
    OfficesCount: "7 Offices",
    OfficesCountAbout: "Seven offices in central cities of Russia",
    gmpPlus: "GPP+",
    gmpPlusAbout: "First premix company in Russia certified under GMP+ system",
    megamixGroupb2bCardText: "Megamix Group comprises two modern premix plants, two feed mills and CHUVA Agroholding. This provides our partners with access to a wide range of products and services covering all aspects of agricultural production.",
    ExpertSupportTitle: "Expert support",
    ExpertSupportText: "Continuous Research and development: Our research and development department is constantly working to improve the range and quality of our products. We use advanced technologies and knowledge to offer our customers innovative solutions that meet their needs.",
    HighQualityTitle: "High quality",
    HighQualityText: "Full traceability system of raw materials and finished products is one of the key advantages of Megamix Group. The Company guarantees 1:100,000 mixing accuracy ensuring high quality of the final product.",
    EfficientLogisticsTitle: "Efficient logistics",
    EfficientLogisticsText: "Our own logistics system ensures timely product delivery to our partners. It helps optimize the delivery process and minimize risks of delay – an important advantage for our customers.",
    ContinuousRDTitle: "Continuous R&D",
    ContinuousRDText: "Our own logistics system ensures timely product delivery to our partners. It helps optimize the delivery process and minimize risks of delay – an important advantage for our customers.",
    ReliabilityAndStabilityTitle: "Reliability and stability",
    ReliabilityAndStabilityText: "Megamix Group is a reliable partner ready to support your business at all times. We strive for long-term relationships based on trust and mutually beneficial cooperation.",
    LargePortfolioTitle: "Large portfolio and production capacities",
    LargePortfolioText: "Megamix Animal Nutrition Company operates high production capacities capable of meeting the needs of any livestock/poultry farm. Our plant in Lipetsk Region produces up to 180,000 tonnes annually, or 900 bags per hour.",
    history: "history",
    History: "History",
    mission: "mission",
    Mission: "Mission",
    strategy: "strategy",
    Strategy: "Strategy",
    video: "video",
    Video: "Video",
    gallery: "photo gallery",
    Gallery: "Photo Gallery",
    toWebsiteButton: "Website",
    Megaschool: "Megaschool",
    watch_on_Youtube: "Watch",
    Megakorm_website: "Megakorm website",
    catalogSwiperCircle: "Products Products Products Products Products",
    materialsSwiperCircle: "Materials Materials Materials",
    searchErrorMessage: "Nothing was found for this query.",
    loadingProcess: "Loading...",
    loadMore: "Load more",
    watchAll: "view all",
    resetAll: "Reset all",
    specializations: "Specializations",
    allSpecializations: "All specializations",
    search: "Search",
    photoReport: "Photo-report",
    videoReport: "Video-report",
    otherNews: "Other news",
    readAll: "read all",
    moreDetailedTest: "More detailed",
    externalLinks: "external links",
    BackToCatalog: "Back to the catalog",
    PurposeOfProduct: "Purpose",
    ProductComposition: "Composition",
    ProductApplication: "Application",
    Vacancies: "Vacancies",
    release: "release",
    cookie: "By using our website, you agree that we use",
    ok: 'Ok',
    agree: "agree",
    agree1: "I consent to the processing of personal data and agree to the terms of the ",
    agree2: "Personal Data Processing and Protection Policy",
    office: 'Offices',
    ...for_farmers_en,
    ...detailsAboutSlide_en,
    ...labs_en,
    ...footerFormEn,
    ...consulting_cn,
    ...products_en,
    ...trading_en,
    ...en_testing
}

export default en
